import React, { FC, useState } from 'react';
import { px2rem } from '../../core';
import Modal, { ModalProps } from '../../common/components/modal/Modal';
import { DesignSettings } from '@mnz/builder';
import StyledComponent from '../../core/StyledComponent';
import { Box, useTheme } from '@mui/material';
import { Close } from '@menuzen/icon/build/outline';
import { Swiper, SwiperSlide } from 'swiper/react';
import { ImageProps } from './ImageGallerySetting';
import { Navigation } from 'swiper';

interface ImageModalProps extends ModalProps {
    selectedImage: number | null;
    designSettings: DesignSettings;
    images: ImageProps[];
}

const ImageModal: FC<ImageModalProps> = ({ selectedImage, images, ...props }) => {
    const theme = useTheme();
    const [currentImage, setCurrentImage] = useState(0);
    return (
        <Modal
            {...props}
            xs={{
                padding: px2rem(15),
                paddingBottom: px2rem(25),
                borderRadius: `${px2rem(10)}`,
                backgroundColor: 'white',
                maxWidth: 300,
            }}
            sm={{
                maxWidth: 400,
            }}
            md={{
                maxWidth: 500,
            }}
        >
            <StyledComponent
                xs={{
                    display: 'flex',
                    justifyContent: 'end',
                }}
            >
                <StyledComponent
                    xs={{
                        width: px2rem(20),
                        height: px2rem(20),
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontSize: px2rem(20),
                        cursor: 'pointer',
                        color: theme.palette.primary70,
                    }}
                    onClick={props.onClose}
                >
                    <Close />
                </StyledComponent>
            </StyledComponent>
            <StyledComponent xs={{ marginTop: `${px2rem(12)}` }}>
                {images.length > 0 && (
                    <Swiper
                        initialSlide={selectedImage}
                        navigation={true}
                        slidesPerView={1}
                        centeredSlides={true}
                        modules={[Navigation]}
                        onRealIndexChange={(element) => setCurrentImage(element.activeIndex)}
                        onInit={(element) => setCurrentImage(element.activeIndex)}
                    >
                        {images.map((image, idx) => (
                            <SwiperSlide key={idx}>
                                <Box
                                    sx={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        width: '100%',
                                        height: '100%',
                                    }}
                                >
                                    <img
                                        src={image.url}
                                        onSelect={() => console.log('idx')}
                                        style={{
                                            objectFit: 'contain',
                                            height: '100%',
                                        }}
                                    />
                                </Box>
                            </SwiperSlide>
                        ))}
                    </Swiper>
                )}
                {images[currentImage] && images[currentImage].caption && (
                    <StyledComponent
                        xs={{
                            fontSize: px2rem(14),
                            lineHeight: px2rem(16),
                            fontFamily: theme.typography.fontFamily,
                            textAlign: 'center',
                            marginTop: px2rem(12),
                        }}
                    >
                        {images[currentImage].caption}
                    </StyledComponent>
                )}
            </StyledComponent>
        </Modal>
    );
};

export default ImageModal;
